(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.WizardPageController', [function wizardPageController() {}]);
})();
